import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { SvgIcon, Typography } from '@material-ui/core';

import InfiniteScroll from '../../commons/InfiniteScroll';
import ProductMiniature from '../../commons/ProductMiniature';
import {
  PRODUCTS_FAVOURITES_REQUESTED,
  PRODUCTS_FAVOURITES_RETRIEVED,
  PRODUCTS_FAVOURITES_FAILED
} from '../../redux/actions/types';
import { getFavouriteProducts } from '../../redux/actions/product';
import LoadingGif from '../../images/Loading.gif';
import { ReactComponent as HeartIcon } from '../../images/Icons/heart.svg';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  productList: {
    padding: theme.spacing(2),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  loadingSection: {
    padding: theme.spacing(2),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  emptyFavorites: {
    width: '100%',
    height: '58vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  heartIcon: {
    width: '50px',
    height: '50px'
  }
});

class Favourites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loadingProducts: false,
      hasMoreProducts: true
    };
  }

  componentDidMount() {
    this.props.getProducts(this.props.user);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.productsStatus !== this.props.productsStatus) {
      if (this.props.productsStatus === PRODUCTS_FAVOURITES_REQUESTED) {
        this.setState({ loadingProducts: true });
      }
      if (this.props.productsStatus === PRODUCTS_FAVOURITES_RETRIEVED) {
        this.setState(state => ({
          loadingProducts: false,
          products: [...state.products, ...this.props.products],
          hasMoreProducts: this.props.products.length === 10
        }));
      }
      if (this.props.productsStatus === PRODUCTS_FAVOURITES_FAILED) {
        this.setState({ loadingProducts: false });
      }
    }
  }

  handleLoadMore = page => {
    this.props.getProducts(this.props.user, page * 10);
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        {this.state.products.length === 0 && this.state.loadingProducts && (
          <div className={classes.loadingSection}>
            <img src={LoadingGif} alt="loading" />
            <Typography color="primary">Cargando Favoritos...</Typography>
          </div>
        )}
        <div className={classes.productList}>
          {this.state.products.length === 0 && !this.state.loadingProducts && (
            <div className={classes.emptyFavorites}>
              <SvgIcon className={classes.heartIcon}>
                <HeartIcon />
              </SvgIcon>
              <Typography style={{ fontWeight: 600, fontSize: '1.5rem' }}>
                {this.props.t('favouritesNotFound', { ns: 'dresser' })}
              </Typography>
              <Typography>
                {this.props.t('saveProducts', { ns: 'dresser' })}
              </Typography>
            </div>
          )}

          <InfiniteScroll
            pageStart={1}
            pageSize={10}
            active={this.props.active === undefined ? this.props.active : true}
            hasMore={this.state.hasMoreProducts}
            loadMore={this.handleLoadMore}
            loading={this.state.loadingProducts}
            loadWhenSpaceLeft={false}
          >
            {this.state.products.map(product => (
              <ProductMiniature key={product.id} product={product} />
            ))}
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  products: state.product.favouriteProducts,
  productsStatus: state.product.status
});

const mapDispatchToProps = dispatch => ({
  getProducts: (user, offset, pageSize) =>
    dispatch(getFavouriteProducts(user, offset, pageSize))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Favourites))
);
